import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';

interface QuoteDialogProps {
  open: boolean;
  onClose: () => void;
  productName?: string;
}

const QuoteDialog: React.FC<QuoteDialogProps> = ({ open, onClose, productName }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  if (!open) return null;

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
  };

  const close = () => {
    setSent(false);
    setName('');
    setEmail('');
    setCompany('');
    setMessage('');
    onClose();
  };

  return (
    <div className="va-modal-backdrop" onClick={close} role="presentation">
      <div
        className="va-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1rem' }}>
          <div>
            <h2 id="quote-title" className="va-h3">
              {sent ? 'Request received' : 'Request a quote'}
            </h2>
            <p className="va-body" style={{ marginTop: '0.4rem' }}>
              {sent
                ? 'Our supply team will follow up with availability and pricing.'
                : productName
                  ? `Tell us what you need for ${productName}.`
                  : 'Share site requirements and we will confirm supply options.'}
            </p>
          </div>
          <button type="button" className="va-menu-btn" aria-label="Close" onClick={close}>
            <X size={16} weight="bold" />
          </button>
        </div>

        {sent ? (
          <div className="va-modal-actions">
            <button type="button" className="va-btn va-btn-primary" onClick={close}>
              Done
            </button>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
            <div className="va-field">
              <label htmlFor="quote-name">Full name</label>
              <input id="quote-name" required value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="va-field">
              <label htmlFor="quote-email">Work email</label>
              <input
                id="quote-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="va-field">
              <label htmlFor="quote-company">Company / site</label>
              <input id="quote-company" value={company} onChange={(e) => setCompany(e.target.value)} />
            </div>
            <div className="va-field">
              <label htmlFor="quote-message">Quantity and specs</label>
              <textarea
                id="quote-message"
                rows={4}
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Tonnes, packaging, delivery location..."
              />
            </div>
            <div className="va-modal-actions">
              <button type="button" className="va-btn va-btn-secondary" onClick={close}>
                Cancel
              </button>
              <button type="submit" className="va-btn va-btn-primary">
                Send request
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default QuoteDialog;
